import React, { useState } from 'react';
import { useForm } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";
import { Button, Form, message, Modal, Select, Spin } from "antd";
import dayjs from "dayjs";

interface IProps {
  getReport: (payload: {
	year: number;
	language: string;
  }) => Promise<Blob>;
  show: boolean;
  onHide: () => void;
}

const ReportCompanyWarehousesModal = (props: IProps) => {
  const [form] = useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedYear, setSelectedYear] = useState<string>('');
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');

  const languages = [
	{ key: "ky", label: "Кыргызский" },
	{ key: "ru", label: "Русский" }
  ];

  const years = Array.from({ length: 20 }, (_, i) => (2025 - i).toString());

  const handleSubmit = async () => {
	try {
	  const values = await form.validateFields();
	  setLoading(true);

	  const payload = { year: Number(selectedYear), language: selectedLanguage }

	  const blob = await props.getReport(payload);


	  const url = window.URL.createObjectURL(blob);
	  const link = document.createElement("a");
	  link.href = url;
	  link.setAttribute(
		"download",
		`Report_${ payload }_${ dayjs().format("YYYY-MM-DD") }.xlsx`
	  );
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);

	  message.success(t('reports.download_success'));
	} catch (error: any) {
	  Modal.error({
		title: t("msg.error"),
		content: error.message || t('reports.download_failed'),
	  });
	} finally {
	  setLoading(false);
	}
  };

  const handleHide = () => {
	form.resetFields();
	setSelectedYear('');
	setSelectedLanguage('');
	props.onHide();
  };

  return (
	<Modal
	  title={ t('reports.report_by_company_warehouses') }
	  open={ props.show }
	  onCancel={ handleHide }
	  onOk={ handleSubmit }
	  okText={ t('general.create') }
	  width={ 700 }
	  footer={ null }
	>
	  <Spin spinning={ loading } tip={ t('reports.loading') }>
		<Form form={ form } layout="vertical" autoComplete="off">
		  <div style={ { display: "flex", gap: "10px" } }>
			<Form.Item
			  name="year"
			  label={ t('reports.select_years') }
			  rules={ [{ required: true, message: t('msg.fill_in_the_field') }] }
			>
			  <Select
				style={ { width: "300px" } }
				value={ selectedYear }
				onChange={ setSelectedYear }
				placeholder={ t('reports.select_years') }
			  >
				{ years.map((year) => (
				  <Select.Option key={ year } value={ year }>
					{ year }
				  </Select.Option>
				)) }
			  </Select>
			</Form.Item>
			<Form.Item
			  label={ t('reports.select_language') }
			  name="select_language"
			  rules={ [{ required: true, message: t('msg.fill_in_the_field') }] }
			>
			  <Select
				value={ selectedLanguage }
				onChange={ setSelectedLanguage }
				style={ { width: "300px" } }
				placeholder={ t('reports.select_language') }
			  >
				{ languages.map((lang) => (
				  <Select.Option key={ lang.key } value={ lang.key }>
					{ lang.label }
				  </Select.Option>
				)) }
			  </Select>
			</Form.Item>
		  </div>
		  <div style={ { textAlign: "right", marginTop: "20px" } }>
			<Button type="primary" block onClick={ handleSubmit } style={ { width: "200px" } }>
			  { t('reports.download_report') }
			</Button>
		  </div>
		</Form>
	  </Spin>
	</Modal>
  );
};

export default ReportCompanyWarehousesModal;
